import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Raven from 'raven-js';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import api from '../../api';
// Custom Components
import LoginBlock from '../../components/LoginBlock';
import styles from './styles';

class SuccessfulDonation extends Component {
  state = {
    mealCount: 0
  };

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    let nid = urlParams.get('id');

    api
      .getReceiptMealcount({ nid })
      .then(mealCount => {
        console.log(mealCount);
        this.setState({ mealCount });
      })
      .catch(err => {
        console.log(err);
      });
  }

  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, { extra: errorInfo });
  }

  _handleSuccessDone = () => {
    this.props.changePage('/add');
  };

  render() {
    const { loggedIn, classes } = this.props;
    const { mealCount } = this.state;

    if (!loggedIn) {
      return <LoginBlock />;
    }

    return (
      <Grid container className={classes.root} spacing={0}>
        <h1
          style={{
            textAlign: 'center',
            color: 'rgba(0,0,0,0.7)'
          }}>
          Thank you!
        </h1>

        <h2
          style={{
            textAlign: 'center',
            color: 'rgba(0,0,0,0.5)'
          }}>
          Your generous donation has been submitted
        </h2>

        <h2 style={{ textAlign: 'center' }}>
          {(+mealCount).toFixed(1)} meal{mealCount > 1 && 's'}
        </h2>

        <Button
          variant="raised"
          color="primary"
          className={classes.callOrganisationButton}
          onClick={this._handleSuccessDone}>
          Done
        </Button>
      </Grid>
    );
  }
}

SuccessfulDonation = withStyles(styles)(SuccessfulDonation);

const mapStateToProps = state => ({
  loggedIn: state.user.loggedIn
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage: url => push(url)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SuccessfulDonation);



// WEBPACK FOOTER //
// ./src/containers/successful_donation/index.js